import axios from "axios";
import AppCookie from "../helpers/AppCookie";

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Credentials': true
    },
    withCredentials: false
});

// Add a request interceptor
axiosClient.interceptors.request.use(function (config) {
    let token = AppCookie.getCookie('token');
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['domain'] = process.env.REACT_APP_DOMAIN;

    // Prevent browser from caching GET API responses
    if (config.method === 'get') {
        config.params = {
            ...config.params,
            _t: Date.now()
        };
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axiosClient.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    return Promise.reject(error);
});

export default axiosClient;
